import { render, staticRenderFns } from "./VerifyToken.vue?vue&type=template&id=234f324e&scoped=true&"
import script from "./VerifyToken.vue?vue&type=script&lang=js&"
export * from "./VerifyToken.vue?vue&type=script&lang=js&"
import style0 from "./VerifyToken.vue?vue&type=style&index=0&id=234f324e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f324e",
  null
  
)

export default component.exports